import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sweepstakes-verification.magic.css.js';
import script from './sweepstakes-verification.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sweepstakes-verification",attrs:{"part":"sweepstakes-verification"}},[_c('magic-ui-text',{staticClass:"sweepstakes-verification__title",attrs:{"part":"sweepstakes-verification__title","content":_vm.$t('sweepstakes.verification-title')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"sweepstakes-verification__text",attrs:{"part":"sweepstakes-verification__text","content":_vm.$t('sweepstakes.verification-text')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"sweepstakes-verification__documents-title",attrs:{"part":"sweepstakes-verification__documents-title","content":_vm.$t('sweepstakes.verification-documents-title')}}),_vm._v(" "),_c('div',{staticClass:"sweepstakes-verification__document-section",attrs:{"part":"sweepstakes-verification__document-section"}},[_c('magic-ui-icon',{staticClass:"sweepstakes-verification__icon",attrs:{"name":"user-id","part":"sweepstakes-verification__icon"}}),_vm._v(" "),_c('magic-ui-text',{attrs:{"content":_vm.$t('sweepstakes.verification-id-title')}})],1),_vm._v(" "),_c('div',{staticClass:"sweepstakes-verification__document-section",attrs:{"part":"sweepstakes-verification__document-section"}},[_c('magic-ui-icon',{staticClass:"sweepstakes-verification__icon",attrs:{"name":"location","part":"sweepstakes-verification__icon"}}),_vm._v(" "),_c('magic-ui-text',{attrs:{"content":_vm.$t('sweepstakes.verification-address-title')}})],1),_vm._v(" "),_c('magic-ui-text',{staticClass:"sweepstakes-verification__footer",attrs:{"part":"sweepstakes-verification__footer","content":_vm.$t('sweepstakes.verification-footer')}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"sweepstakes-verification__button",attrs:{"part":"sweepstakes-verification__button","variant":"primary","large":""},domProps:{"innerHTML":_vm._s(_vm.$t('sweepstakes.verification-continue'))},on:{"click":_vm.onContinue}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e66fd7b4_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-e66fd7b4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
